import styles from "./departure-row.module.css";

/** A character that cannot occur in operator copy, used to mark where the
 *  amount goes so the sentence can be split around it. The translator returns
 *  a plain string, so the only other way to bold one word inside a translated
 *  sentence is to split the English on the money text itself — which breaks the
 *  moment a currency symbol also appears elsewhere in the sentence. */
export const AMOUNT_SLOT = " ";

/** Guide `.bn-dep b` — the money is the one word in this sentence that gets
 *  read on its own, so it takes the heading colour and weight while the rest
 *  stays quiet. Falls back to the sentence as-is when a translation has
 *  dropped the `{amount}` token, rather than losing the number entirely. */
export function EmphasisedAmount({
  sentence,
  amount,
}: {
  sentence: string;
  amount: string;
}) {
  const [before, after] = sentence.split(AMOUNT_SLOT);
  if (after === undefined) return <>{sentence.replace(AMOUNT_SLOT, amount)}</>;
  return (
    <>
      {before}
      <b className={styles.amount}>{amount}</b>
      {after}
    </>
  );
}

/** ISO date from a Date, in LOCAL time. `toISOString()` would shift a date
 *  across the day boundary for anyone west of UTC — the end date of a trip is
 *  a calendar day, not an instant. */
export function toIsoDate(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
